(function() {
  var metaRelatedSlider = function() {
    var slide = $('.metaRelateSlider');
    slide.flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      groupCells: true,
      adaptiveHeight: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
      // some code..

      slide.on( 'dragStart.flickity', function() {
        $('body').addClass("no-scroll");
      });
      slide.on( 'dragMove.flickity', function() {
        $('body').addClass("no-scroll");
      });
      slide.on( 'dragEnd.flickity', function() {
        $('body').removeClass("no-scroll");
      });
 
    }
    
    setTimeout(function(){
      $('.product__media-gallery').addClass('active');
    },700); 

    setTimeout(function(){
     
      
      if ($('.slider-mobile-gutter.starapps:not(.thumbnail-slider) li').length > 4 ){
        $('.product__media-gallery').removeClass('lessMedia');
      }
      else{
        $('.product__media-gallery').addClass('lessMedia');
      }
      
      if ($('.slider-mobile-gutter.starapps:not(.thumbnail-slider) li').length > 6 ){
        $('.prductMediaLessMore').show();
      }
      else{
        $('.prductMediaLessMore').hide();
      }
    },1000);
 

    // create a scene
    var ScrollHeight = $('.metaRelatedProducts').height();
    var controller = new ScrollMagic.Controller({globalSceneOptions: {duration: ScrollHeight}}); 
    new ScrollMagic.Scene({triggerElement: ".metaRelatedProducts"})
    .setClassToggle(".metaRelatedProducts", "active") // add class toggle
//     .addIndicators() // add indicators (requires plugin)
    .addTo(controller);
  };

  var prductMediaLessMore = function(){
    $(document).on('click','.prductMediaLessMore',function(e){
     e.preventDefault();
      $('.product__media-list').parent().toggleClass('productShowImages');
      $(this).text(function(i, text){
          return text === "Show More Images" ? "Show Less Images" : "Show More Images";
      })
    })
  };
 
  
  $(document).on('click','.product-form__input label',function(e) { 
    var optionIndex = jQuery(this).closest('.product-form__input').attr('data-option-index');
    var optionValue = jQuery(this).data('value');
    $(this)
    .parents('.product__info-container')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
//     var select = document.querySelector('.single-option-selector')[0];
//      select.value = optionValue;
//     select.dispatchEvent(new Event('change'));
  });
  
  $(document).on('click','.quickAddToCart',function(e){
    e.preventDefault();
    var id = $(this).data('val');  
    $.ajax({
      type:"post",
      dataType: "json",
      url: '/cart/add.js',
      data:{quantity:1,id:id},
      success: function(data){
         //window.location.href = '/cart';
        jQuery.getJSON('/cart.js', function(cart) { 
          window.SLIDECART_SET_CART(cart);
          window.SLIDECART_OPEN()
        });
      }
    });
  });

 
  metaRelatedSlider();
  prductMediaLessMore();

  $(document).on('shopify:section:load', function(event) { 
    metaRelatedSlider();
    prductMediaLessMore();
  });
}());
 
document.addEventListener('DOMContentLoaded', function(){
  $(document).on('click','.offerApply',function(e){
    var offerTxt = $(this).data('offer');
    localStorage.setItem("offerApplied", offerTxt);
  })
  var getofferApplied = localStorage.getItem("offerApplied");
  if( getofferApplied != undefined && getofferApplied != ''){
    $('.offerterm').css('background-color', '#3088d7');
    $('.offerterm').html(getofferApplied);
  }
  setTimeout(function(){
    var average_rating = $('.jdgm-rev-widg').data('average-rating');
//     console.log(average_rating);
    $('.jdgm-rev-widg__summary').prepend('<div class="jdgm-rev__avgRate">'+average_rating+'</div>');
  },1500); 
}); 